import { forwardRef } from "react";
import {
  IconButtonProps,
  IconButton as MuiIconButton,
  styled,
} from "@mui/material";

import { BUTTON_COLORS } from "../../constants";
import CircularProgress from "../CircularProgress";

const StyledIconButton = styled(MuiIconButton)(({ color = "primary" }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: BUTTON_COLORS[color as keyof typeof BUTTON_COLORS],
  padding: 0,
  borderRadius: "4px",
  border: `1px solid ${
    BUTTON_COLORS[`${color}Border` as keyof typeof BUTTON_COLORS]
  }`,
  color: `${BUTTON_COLORS[`${color}Text` as keyof typeof BUTTON_COLORS]}`,

  "&:hover": {
    background: `${
      BUTTON_COLORS[`${color}Hover` as keyof typeof BUTTON_COLORS]
    }`,
  },

  "&.Mui-disabled": {
    border: "none",
    background: "rgba(0, 0, 0, 0.12)",
    color: `${BUTTON_COLORS[`${color}Text` as keyof typeof BUTTON_COLORS]}`,
  },
}));

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, loading, ...props }, ref) => {
    return (
      <StyledIconButton
        ref={ref}
        loading={loading}
        loadingIndicator={<CircularProgress color="inherit" size="sm" />}
        {...props}
      >
        {!loading && children}
      </StyledIconButton>
    );
  },
);

export default IconButton;
